import { Review } from '../../../types';

export class ReviewMapper {
    static toDomain(r: any): Review {
        return {
            id: r.id,
            listingId: r.listing_id,
            userId: r.user_id,
            userName: r.user_name || 'Anonym',
            rating: r.rating,
            comment: r.comment,
            createdAt: r.created_at
        };
    }

    static toRow(review: Omit<Review, 'id' | 'createdAt'> & { id?: string; createdAt?: string }): any {
        return {
            id: review.id || crypto.randomUUID(),
            listing_id: review.listingId,
            user_id: review.userId,
            user_name: review.userName,
            rating: review.rating,
            comment: review.comment,
            created_at: review.createdAt || new Date().toISOString()
        };
    }
}
